import React, { useEffect } from 'react';
import classnames from 'classnames';
import { useDialogContext } from './dialog-context-provider';
import { ModalFooter, ModalFooterProps } from '../modal/modal-footer';

export type DialogFooterProps = ModalFooterProps;

export const DialogFooter = ({ className, ...props }: DialogFooterProps): React.ReactElement => {
  const classNames = classnames(className, 'airtame-dialog__footer');
  const { disableLegacy } = useDialogContext();
  useEffect(() => disableLegacy(), []);

  return <ModalFooter {...props} className={classNames} />;
};
